// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"725":"2414621d","879":"69812494"}[chunkId] + ".css";
};